<template>
  <v-toolbar-title>
    <v-icon :color="$vuetify.theme.dark ? '#647E98' : '#171717'">
      mdi-view-dashboard
    </v-icon>
    <span v-if="isDashboard">Hello! {{ `${loggedAdmin?.fname || ''} ${loggedAdmin?.lname || ''}` }}</span>
    <span v-else>{{ currentPageTitle }}</span>
  </v-toolbar-title>
</template>

<script>
import {  mapState } from "vuex";

export default {
  data() {
    return {
      currentPageTitle: '',
      specialTitles: {
        'registered-user': 'Registered Users',
        'documents': 'Documents',
        'live-accounts': 'Live Accounts',
        'demo-accounts': 'Demo Accounts',
        'blocked-users': 'Blocked Users'
      },
      tabTitles: {
        '1': 'Registered Users',
        '2': 'Documents',
        '3': 'Live Accounts',
        '4': 'Demo Accounts',
        '5': 'Blocked Users',
        '6': 'Inactive Accounts',
        '7': 'Low Balance Accounts',
        '8': 'Testing Accounts'
      }
    };
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
    isDashboard() {
      return this.$route.path === '/dashboard';
    },
  },
  methods: {
    updatePageTitle() {
      if (!this.isDashboard) {
        const path = this.$route.path.split('/').pop();
        const queryParams = this.$route.query;
        this.currentPageTitle = this.getPageTitle(path, queryParams);
      }
    },
    getPageTitle(path, queryParams) {
      // Check if we have a tab parameter
      if (queryParams.tab && this.tabTitles[queryParams.tab]) {
        return `${this.tabTitles[queryParams.tab]}`;
      }

      // If no tab parameter or unknown tab, use the special title or format the path
      return this.specialTitles[path] || this.formatPageTitle(path);
    },
    formatPageTitle(title) {
      // Handle kebab-case (e.g., "registered-user")
      if (title.includes('-')) {
        return title.split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }

      // Handle camelCase or PascalCase (e.g., "PartnerList")
      return title.replace(/([A-Z])/g, ' $1')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
  async mounted() {
    this.updatePageTitle();
  },
  watch: {
    $route() {
      this.updatePageTitle();
    },
  },
};
</script>